import { Component } from 'react'
import { getNoBidClientStyle } from 'utils/helpers'
import s from './CompanyCellRenderer.scss'
import { Link } from 'react-router-dom'

class CompanyCellRenderer extends Component {
  render() {
    const { data } = this.props
    if (!data) return null
    return (
      <Link
        to={`/companies/${data.company.id}`}
        className={s.link}
        style={getNoBidClientStyle(data.company.noBid)}
      >
        {data.company.name}
      </Link>
    )
  }
}

export default CompanyCellRenderer
